import React, { PureComponent } from 'react';

class ImporteSinIva extends PureComponent {
    constructor(props) {
        super(props);
    }

    onClickFunction(event) {
        let result = event.key == " " ? false : true;
        if (!result) {
            event.preventDefault();
        }
        var rgx = /^[.0-9 ]+$/;
        let resp = rgx.test(event.key);

        if (!resp) {
            event.preventDefault();
        }
    }

    handleChange = (campo, campoError, e) => {
        let result = e.target.value == " " ? false : true;
        if (!result) {
            e.preventDefault();
        }

        let respregNumPunto = /^[0-9]{1,13}[.]{1}$/;
        let regImporteSinIva = /^[0-9]{1,13}[.][0-9]{1,2}$|^[0-9]{1,13}$/;

        let respregImporteSinIva = regImporteSinIva.test(e.target.value);
        let resprespregNumPunto = respregNumPunto.test(e.target.value);

        if(e.target.value == ""){
            this.props.actualizarImporteSinIVA(campo, campoError, e.target.value, false);
        } else if (respregImporteSinIva) {
            this.props.actualizarImporteSinIVA(campo, campoError, e.target.value, false);
        } else if (resprespregNumPunto) {
            this.props.actualizarImporteSinIVA(campo, campoError, e.target.value, true);
        } else {
            e.preventDefault();
            e.isPropagationStopped();
        }
    }

    render() {

        const { min, max, errorMin, errorMax } = this.props;

        return (
            <div className={"confirmadorAjusteCargoSeccionSuperiorDiv confirmadorAjusteCargoSeccionSuperiorPaddingLeft"}>
                <label className="confirmadorAjusteCargoSeccionSuperiorLblPpal">Importe sin iva</label>
                <div>
                    <label htmlFor="Min" className={"confirmadorAjusteCargoSeccionSuperiorMinMax"}>Min</label>
                    <input type="text"  value={min} onKeyPress={this.onClickFunction} onChange={(e) => this.handleChange("min", "errorMin", e)} className={"confirmadorAjusteCargoSeccionSuperiorMinMaxInput"} />
                    {errorMin && <label style={{ marginLeft: '37px' }} className="error modal-estados-label-error">Formato Incorrecto</label>}
                </div>
                <div className={"confirmadorAjusteCargoSeccionSuperiorDivMarginTop"}>
                    <label htmlFor="Max" className={"confirmadorAjusteCargoSeccionSuperiorMinMax"}>Max</label>
                    <input type="text" value={max} onKeyPress={this.onClickFunction} onChange={(e) => this.handleChange("max", "errorMax", e)} className={"confirmadorAjusteCargoSeccionSuperiorMinMaxInput"} />
                    {errorMax && <label style={{ marginLeft: '37px' }} className="error modal-estados-label-error">Formato Incorrecto</label>}
                </div>
            </div>
        );
    }
}

export default ImporteSinIva;